import React, { Component } from "react";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, success_url, GET, PUT, validate, required, loading } from "../../components/CustomComponent.js";

const PERMS = ["view", "create", "update", "delete"];
const ALL_PERMS = [...PERMS, "approved"];

export default class EditRoleUserScreen extends Component {
    // คัดลอก global.role แบบ Deep Copy ป้องกันการแก้ไขตัวแปร global โดยตรง
    state = { role_name: "", role_description: "", role_detail: JSON.parse(JSON.stringify(global.role)) };

    componentDidMount() {
        this.GetById(this.props.location.query.id);
    }

    GetById = async (id) => {
        loading(true);
        let res = await GET(tokens, `v1/TH/role-manage/detail/${id}`, null);
        if (res?.status) {
            let { role_name, role_description, role_detail: fetchedData } = res.data.data;
            let rd = [...this.state.role_detail];
            
            // NOTE เมนูที่มีใน role_detail แต่ไม่มีใน global.role (เช่นเมนูของบทบาทเจ้าของระบบ
            // อย่าง project / receipt / invoice-by-room) ต้องเก็บต่อไว้ด้วย mark เป็น hidden
            // ไม่งั้นกดบันทึกครั้งเดียวสิทธิ์พวกนี้จะหายไปเงียบ ๆ เพราะตอนส่งกลับส่งเฉพาะแถวที่อยู่ในโครง
            fetchedData.forEach(fData => {
                let match = rd.find(r => r.permission && r.menu_name === fData.menu_name);
                if (match) return ALL_PERMS.forEach(k => match.permission[k] = fData.permission[k] === "true");

                let permission = {};
                ALL_PERMS.forEach(k => permission[k] = fData.permission[k] === "true");
                rd.push({ menu_name: fData.menu_name, permission, hidden: true });
            });

            this.setState({ role_name, role_description, role_detail: rd });
        }
        loading(false);
    };

    Update = async () => {
        if (validate(this.state, ["role_name"])) return;
        loading(true);

        // แปลง boolean กลับเป็น string "true"/"false" ตามโครงสร้าง API
        let mappedRole = this.state.role_detail.filter(e => e.permission).map(item => {
            let permStr = {};
            ALL_PERMS.forEach(k => permStr[k] = String(!!item.permission[k]));
            return { menu_name: item.menu_name, permission: permStr };
        });

        let data = {
            role_id: this.props.location.query.id,
            role_name: this.state.role_name,
            role_description: this.state.role_description,
            role_detail: mappedRole,
        };

        let result = await PUT(tokens, "v1/TH/role-manage/update", data);
        if (result?.status) success_url("/role");
        loading(false);
    };

    // รวบฟังก์ชัน select_role และ select_all_role ไว้ด้วยกัน
    actionRole = (type, val, index = null) => {
        let rd = [...this.state.role_detail];
        if (index !== null) {
            let p = rd[index].permission;
            if (type === "all") ALL_PERMS.forEach(k => p[k] = !p[k]);
            else p[type] = !p[type];
        } else {
            rd.forEach(r => {
                if (r.permission && !r.hidden) {
                    if (type === "all") ALL_PERMS.forEach(k => r.permission[k] = val);
                    else r.permission[type] = val;
                }
            });
        }
        this.setState({ role_detail: rd });
    };

    render() {
        const { role_name, role_description, role_detail } = this.state;
        const cols = [
            { id: "all", name: "ทั้งหมด" }, { id: "view", name: "ดูข้อมูล" },
            { id: "create", name: "เพิ่มข้อมูล" }, { id: "update", name: "แก้ไขข้อมูล" }, { id: "delete", name: "ลบข้อมูล" }
        ];

        return (
            <div className="full bg-contain fade-in">
                <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="รายชื่อผู้ใช้ทั้งหมด" />

                <div className="body mb-4 pb-4">
                    <div className="row">
                        <div className="col-12 col-md-10 col-xl-8 p-3 mx-auto">
                            <div className="w-100 d-flex align-items-center justify-content-between px-3 mt-5">
                                <h4 className="w-100"><b>เพิ่มบทบาทผู้ใช้</b></h4>
                            </div>

                            <div className="w-100 p-3">
                                <div className="card rounded">
                                    <div className="card-body">
                                                                            <div className="d-flex mx-0 align-items-center mb-3">
                                                                                <span className="wpx-100">ชื่อบทบาท{required}:</span>
                                                                                    <input type="text" className="form-control validate" placeholder="กรอกข้อมูล" value={role_name} onChange={(e) => this.setState({ role_name: e.target.value })} />
                                    
                                                                            </div>
                                                                            <div className="d-flex mx-0 align-items-start">
                                                                                <span className="wpx-100 mt-1">รายละเอียด:</span>
                                                                                    <textarea className="form-control validate" placeholder="กรอกข้อมูล" rows={5} value={role_description} onChange={(e) => this.setState({ role_description: e.target.value })} />
                                                                            </div>
                                                                        </div>
                                </div>
                            </div>

                            <div className="w-100 p-3" style={{ marginBottom: 100 }}>
                                <div className="card rounded">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-borderless">
                                                <thead>
                                                    <tr className="bg-dark-blue text-white">
                                                        <th className="text-left">เมนูจัดการ</th>
                                                        {cols.map(c => (
                                                            <th key={c.id} className="text-center">
                                                                {c.name} <br />
                                                                <input className="mt-2" type="checkbox"
                                                                    checked={!role_detail.some(e => e.permission && !e.hidden && (c.id === "all" ? PERMS.some(p => !e.permission[p]) : !e.permission[c.id]))}
                                                                    onChange={(e) => this.actionRole(c.id, e.target.checked)} />
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* แถว hidden = เมนูที่ไม่มีในตารางนี้แต่ต้องเก็บค่าไว้ (ดู GetById) */}
                                                    {role_detail.map((item, i) => item.hidden ? null : (
                                                        <tr key={i} className={item.permission ? "" : "bg-contain"}>
                                                            <td className="text-nowrap">{global.roleth[item.menu_name]}</td>
                                                            {cols.map(c => (
                                                                <td key={c.id} className="text-center">
                                                                    {item.permission && (
                                                                        <input type="checkbox"
                                                                            checked={c.id === "all" ? PERMS.every(p => item.permission[p]) : item.permission[c.id]}
                                                                            onChange={() => this.actionRole(c.id, null, i)} />
                                                                    )}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body px-3 pt-3 bg-white position-fixed" style={{ bottom: 0 }}>
                    <div className="row mx-0">
                        <div className="ml-auto col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                            <button type="button" className="btn btn-outline-primary w-100 px-4" onClick={() => window.location.href = "/role"}>
                                        <span className="icon-brand mr-2">{"\uf060"}</span>ย้อนกลับ
                                    </button> </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                            <button className="btn btn-primary w-100" onClick={this.Update}>บันทึก</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}